// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The completion manager token.
 */
export const ICompletionManager = new Token('@jupyterlab/completer:ICompletionManager');
//# sourceMappingURL=tokens.js.map